const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/spero-ultron-service-staging' : 'api/spero-ultron-service'
const urls = {
  /*
  * 获取图形验证码
  * */
  captcha: 'post /public/captcha',
  // 图形验证码 获取验证码
  getVerifyCode2: 'post /public/sms/verifyCode',

  bindMobilephone2: 'put /user/phone/bind',

  searchUser: 'get /search/user',
  userInfo: 'get /user/info',
  pureUserInfo: 'get /user/pureInfo',
  simpleUser: 'get /users/:userId',
  /*
  * 绑定手机
  * body
  *   certification [string] 原手机号
  *   phone: string
  *   verifyCode: string
  * */
  bindMobilephone: 'put /user/phone',

  searchAuthor: 'get /user/author/search',
  /*
  * body
  *   message
  * */
  qrcode: 'post /tool/qrcode',
  // 搜索播主 channel,keyword
  getAuthor: 'get /search/liveUser',
  // 通过uid获取直播间
  searchLiveRoom: 'get /room/author/:authorUid',
  // 获取推广页列表 type page list
  getAgentList: 'get /agentPromotionPage/list',
  // 批量生成二维码 list
  getQrCodelist: 'post /tool/qrcode/batch',
  // 获取链接转换历史记录
  getAgentLinkList: 'get /agentLink/list',
  // 添加转换链接
  sendLink: 'post /agentLink',
  // 查看线索
  viewClue: 'get /user/:userId/keyInfo',
  // 获取报告会列表
  getPromotionList: 'get /room/liveReport/promotionList',

  reportTape: 'get /liveReport/:reportId/tape/:tapeId',

  // 查询播主 1、是否允许进入页面加入群组 2、绑定手机号成功后加入群组
  findGroupIdsByAuthorUid: 'get /authorPromotion/findGroupIdsByAuthorUid',
  // 获取报告会回放链接
  tapePromotionList: 'get /room/liveReport/tapePromotionList',
  // 查询群聊直播间
  groupChatRoom: 'get /search/groupChatRoom',

  liveInfo: 'get /v2/room/:roomId',

  roomDownConfig: 'get /room/:roomId/downloadConfig',

  joinRoom: 'PUT /room/:roomId/join',

  signatureURL: 'get /public/jssdk/config',

  sendLiveComment: 'post /v2/room/:roomId/comments',
  // 芝士律动通过token登录
  zsldLogin: 'post /coop/zsld/login',

  taskShareRecord: 'post /shareRecord',

  completeDailyTask: 'post /points/completeDailyTask',
  // 关注 followId, flag
  follow: 'post /follows'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
